// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:flex;flex-direction:column;height:100%;min-height:0}.root{flex:1 1 auto;height:100%}.root mp-data-table{height:100%}.root .truncated-data-download-text{color:var(--tertiary-text-color);font-size:$font-size-medium;font-weight:$weight-medium;padding:14px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
